// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './css/main.css'
import axios from 'axios'
import VueAxios from 'vue-axios';
import "babel-polyfill";
import Qs from 'qs'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
console.log('axios地址',API_ROOT)
var axios_instance = axios.create({
  baseURL: API_ROOT.baseURL,
  transformRequest: [function (data) {
      data = Qs.stringify(data);
      return data;
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  withCredentials: true
});
axios_instance.interceptors.response.use(res => {
  if (res.data.code == 1001) {
      Message.error(res.data.message);
  } else if (res.data.code == 1000) {
      return res;
  }
}, error => {
  return new Promise.reject(error)
})
Vue.config.productionTip = false
Vue.use(VueAxios, axios_instance);
Vue.use(ElementUI, { size: 'small' });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js